import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      marginTop: theme.spacing(4),
    },
    gridItem: {
      marginTop: theme.spacing(4),
      textAlign: "center",
    },
  })
);
